<div class="flex w-full h-full p-6 gap-6 bg-surface-50 flex-col">
  <p-card>
    <div class="flex flex-col gap-4">
      <div class="flex gap-4 items-center">
        <div class="text-surface-900 font-['Inter'] leading-7">
          Selected Tier:
        </div>
        <p-select
          class="w-60"
          [ngModel]="selectedRateTier"
          [options]="atoRateTiersList"
          (onChange)="setSelectedRateTier($event.value)"
          optionLabel="name"
          placeholder="Select a tier..."
        ></p-select>
      </div>
      <div #scrollContainer class="rounded-lg border border-surface-300 overflow-y-auto">
        <p-table [value]="localRateTier?.rates ?? []">
          <ng-template #header>
            <tr class="text-surface-800">
              <th class="rounded-tl">Name</th>
              <th>Category</th>
              <th class="rounded-tr">Rate</th>
            </tr>
          </ng-template>
          <ng-template #body let-rateDetails let-lastRow="last" let-rowIndex="rowIndex">
            <tr class="text-surface-800">
              <td [ngClass]="{'bg-primary-50': rateDetails.category === 'TownOrCity', 'rounded-bl': (rowIndex === (localRateTier?.rates?.length ?? 0) - 1)}">{{ rateDetails.name }}</td>
              <td [ngClass]="{'bg-primary-50': rateDetails.category === 'TownOrCity'}" >{{ toLocationCategoriesText(rateDetails.category) }}</td>
              <td [ngClass]="{'bg-primary-50': rateDetails.category === 'TownOrCity', 'rounded-br': (rowIndex === (localRateTier?.rates?.length ?? 0) - 1)}">
                <p-inputnumber [(ngModel)]="rateDetails.rate" (ngModelChange)="onRateChange()" inputId="currency-aus" mode="currency" currency="AUD" locale="en-AU"></p-inputnumber>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
      <div class="w-full flex justify-end gap-4">
        <p-button label="Save"
                  icon="fa-regular fa-save"
                  [disabled]="!localRateTierChanged()"
                  (onClick)="saveSelectedRateChanges()"
        ></p-button>
        <p-button label="Cancel"
                  icon="fa-regular fa-cancel"
                  [disabled]="!localRateTierChanged()"
                  (onClick)="cancelSelectedRateTierChanges()"
                  severity="danger"
        ></p-button>
      </div>

      @if (!selectedRateTier) {
        <div class="pl-1"><i>No tier selected.</i></div>
      }
    </div>
  </p-card>

  <div class="p-2.5 w-full"></div>
</div>
